/**
 * Base model of TransactionDetails and installmentDetails
 * @author Tim Sullivan, hkori
 *
 * Presentational attributes of this model:
 * - isRendered: true when the model has been used to render the template before
 * - requestedToShow: true when the user wants to show, false when the user wants to collapse
 */

import Backbone from 'backbone';

let ActivityDetailModel = Backbone.Model.extend({
	defaults: {
		isRendered: false,
		requestedToShow: false
	},

	// when no value is passed whether to show or hide,
	// switch the existing model value
	toggleRequestedToShow(toShow = !this.get('requestedToShow')) {
		this.set('requestedToShow', toShow);
	}
});

export default ActivityDetailModel;



// WEBPACK FOOTER //
// ./model/activity/sharedPanel.es6